import { useReducer } from 'react';
import axios from 'axios';
import { configs } from '../constants/configs/configs';

import { startSpinner, stopSpinner } from '../actions/common/actionCreators';
import { SPINNER_MESSAGES_IDS } from '../constants/common/miscellaneous';


const actions = {
    GET_CUSTOM_FIELDS: 'GET_CUSTOM_FIELDS',
    GET_CUSTOM_FIELD_BY_ID: 'GET_CUSTOM_FIELD_BY_ID',
    POST_CUSTOM_FIELDS_SUCCESS: 'POST_CUSTOM_FIELDS_SUCCESS',
    POST_CUSTOM_FIELDS_FAILURE: 'POST_CUSTOM_FIELDS_FAILURE',
    POST_CUSTOM_FIELDS_EXIST: 'POST_CUSTOM_FIELDS_EXIST',
    PUT_CUSTOM_FIELDS_SUCCESS: 'PUT_CUSTOM_FIELDS_SUCCESS',
    PUT_CUSTOM_FIELDS_FAILURE: 'PUT_CUSTOM_FIELDS_FAILURE',
    PUT_CUSTOM_FIELDS_EXIST: 'PUT_CUSTOM_FIELDS_EXIST',
    RESET_ALL: 'RESET_ALL'

};

const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': 'window.EMAIL',
        'csrftoken': window.csrf_token
    }
});

function reducer(state, { type, payload }) {
    switch (type) {
        case actions.GET_CUSTOM_FIELDS:
            return {
                ...state,
                customFields: payload,
            };
        case actions.GET_CUSTOM_FIELD_BY_ID:
            return {
                ...state,
                customField: payload,
            };
        case actions.POST_CUSTOM_FIELDS_SUCCESS:
            return {
                ...state,
                customFields: [...state.customFields, payload],
                postSuccess:true,
                error:false
            };  
        case actions.POST_CUSTOM_FIELDS_FAILURE:
            return {
                ...state,
                postSuccess:false,
                error:true
            };  
        case actions.POST_CUSTOM_FIELDS_EXIST:
            return {
                ...state,
                postSuccess:false,
                error:false,
                isDuplicate: true
            };   
        case actions.PUT_CUSTOM_FIELDS_SUCCESS: {
            const index = state.customFields.findIndex( item => item.id ===payload.id );
            const newCustomFieldArray = [...state.customFields];
            newCustomFieldArray[index] = { ...state.customFields[index], ...payload };
            return {
                ...state,
                customFields: newCustomFieldArray,
                postSuccess:true,
                error:false
            };  
        }
        case actions.PUT_CUSTOM_FIELDS_FAILURE:
            return {
                ...state,
                postSuccess:false,
                error:true
            };  
        case actions.PUT_CUSTOM_FIELDS_EXIST:
            return {
                ...state,
                postSuccess:false,
                error:false,
                isDuplicate: true
            };   
        case actions.RESET_ALL:
            return {
                ...state,
                postSuccess:false,
                isDuplicate: false,
                error:false
            };       
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, {
        customFields: undefined,
        customField: {},
        postSuccess:false,
        isDuplicate: false,
        error:undefined
    });

    const getCustomFields = async () => {
        try {
            dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
            const res = await api.get(
                global.__ENV__.PRODUCTION
                    ? configs.endpoints.GET_CUSTOM_FIELDS_URL
                    : configs.endpoints.GET_CUSTOM_FIELDS_FOR_DEV_ENVIRONMENT,
            );
            
            if (res && res.data) {
                dispatch(stopSpinner());
                dispatch({ type: actions.GET_CUSTOM_FIELDS, payload: res.data });
            }
        } catch (e) {
            dispatch(stopSpinner());
            dispatch({ type: actions.GET_CUSTOM_FIELDS, payload: [] });
        }
    };

    const getCustomFieldById = async (id) => {
        try {
            const res = await api.get(configs.endpoints.GET_CUSTOM_FIELDS_URL +'/'+id);
            
            if (res && res.data) {
                dispatch({ type: actions.GET_CUSTOM_FIELD_BY_ID, payload: res.data });
            }
        } catch (e) {
            dispatch({ type: actions.GET_CUSTOM_FIELD_BY_ID, payload: [] });
        }
    };

    const postCustomFields = async (data) => {
        api.post(
            configs.endpoints.GET_CUSTOM_FIELDS_URL, data
        ).then(response => {
            dispatch({ type: actions.POST_CUSTOM_FIELDS_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                if(error.response.data.errorType === 'CUSTOM_FIELD_ALREADY_EXISTS'){
                    dispatch({ type: actions.POST_CUSTOM_FIELDS_EXIST, payload: [] });
                }
                else{
                    dispatch({ type: actions.PUT_CUSTOM_FIELDS_FAILURE, error });
                }
            });
    };
    
    const putCustomFields = async (data) => {
        api.put(
            configs.endpoints.GET_CUSTOM_FIELDS_URL, data
        ).then(response => {
            dispatch({ type: actions.PUT_CUSTOM_FIELDS_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                if(error.response.data.errorType === 'CUSTOM_FIELD_ALREADY_EXISTS'){
                    dispatch({ type: actions.PUT_CUSTOM_FIELDS_EXIST, payload: [] });
                }
                else{
                    dispatch({ type: actions.PUT_CUSTOM_FIELDS_FAILURE, error });
                }
            });
    };

    const resetAll = async () => {
        dispatch({ type: actions.RESET_ALL, payload: null });
    };

    return {
        ...data,
        getCustomFields: () => {
            getCustomFields();
        },
        getCustomFieldById: (id) => {
            getCustomFieldById(id);
        },
        postCustomFields: (data) => {
            postCustomFields(data);
        },
        putCustomFields: (data) => {
            putCustomFields(data);
        },
        resetAll: () => {
            resetAll();
        }
    };
};